import {useCallback} from 'react';

import {useRoamingSettings} from '../RoamingSettingsContext';
import {messageSendDialogParent} from '../sendDialogParentMessages';
import EmailSync from './EmailSync';
import LogInPrompt from './LogInPrompt';

interface Props {
  onCancel?: () => void;
  onSubmit?: () => void | Promise<void>;
}

const notifyParent = (payload: {
  status: 'success' | 'cancel';
  notes?: string;
}) => {
  messageSendDialogParent(payload);
};

const SendModal = ({onCancel: rawOnCancel, onSubmit: rawOnSubmit}: Props) => {
  const {podUrl, refreshToken} = useRoamingSettings();
  const isSignedIn = Boolean(refreshToken && podUrl);

  const onSubmit = useCallback(() => {
    if (rawOnSubmit) {
      return rawOnSubmit();
    }
    notifyParent({status: 'success'});
  }, [rawOnSubmit]);

  const onCancel = useCallback(() => {
    if (rawOnCancel) {
      rawOnCancel();
      return;
    }
    notifyParent({status: 'cancel'});
  }, [rawOnCancel]);

  if (isSignedIn) {
    return <EmailSync onCancel={onCancel} onSubmit={onSubmit} />;
  }

  return <LogInPrompt onCancel={onCancel} onSubmit={onSubmit} />;
};

export default SendModal;
